/**
 * 科创服务相关 API
 */
import request from '@/utils/request'
import baseUrl from '@/utils/baseUrl'

const serviceApi = {}

/**
 * 获取图片地址
 * @param {String} fileId 文件ID
 * @returns {String} 图片访问地址
 */
serviceApi.getImageUrl = function(fileId) {
  if (!fileId) {
    return ''
  }
  return `${baseUrl.oss}/file/download/${fileId}`
}

/**
 * 获取服务机构列表
 * @param {Object} params 查询参数
 * @param {Number} params.pageNum 页码（必填）
 * @param {Number} params.pageSize 每页条数（必填）
 * @param {String} params.keyword 查询关键词（可选）
 * @param {String} params.orgType 机构类型，可以传一级或二级的机构类型id（可选）
 * @param {String} params.provinceId 省份id（可选）
 * @returns {Promise} 返回服务机构列表数据
 */
serviceApi.getServiceList = function(params = {}) {
  return request({
    url: '/org-api/portal/service/getList',
    method: 'get',
    params: {
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 10,
      keyword: params.keyword || '',
      orgType: params.orgType || '',
      provinceId: params.provinceId || ''
    },
    baseURL: baseUrl.apiBaseAuth,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

/**
 * 获取服务商品列表
 * @param {Object} params 查询参数
 * @param {Number} params.pageNum 页码（必填）
 * @param {Number} params.pageSize 每页条数（必填）
 * @param {String} params.keyword 查询关键词（可选）
 * @param {String} params.productType 产品类型（可选）：可传一级或二级类型id
 * @param {String} params.provinceId 省份id（可选）
 * @returns {Promise} 返回服务商品列表数据
 */
serviceApi.getProductList = function(params = {}) {
  return request({
    url: '/org-api/portal/service/getProductList',
    method: 'get',
    params: {
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 10,
      keyword: params.keyword || '',
      productType: params.productType || '',
      provinceId: params.provinceId || ''
    },
    baseURL: baseUrl.apiBaseAuth,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

/**
 * 获取服务机构详情
 * @param {String} id 机构id（必填）
 * @returns {Promise} 返回服务机构详情数据
 */
serviceApi.getServiceDetail = function(id) {
  return request({
    url: '/org-api/portal/service/get',
    method: 'get',
    params: {
      id: id
    },
    baseURL: baseUrl.apiBaseAuth,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

/**
 * 获取服务商品详情
 * @param {String} id 产品id（必填）
 * @returns {Promise} 返回服务商品详情数据
 */
serviceApi.getProductDetail = function(id) {
  return request({
    url: '/org-api/portal/service/getProduct',
    method: 'get',
    params: {
      id: id
    },
    baseURL: baseUrl.apiBaseAuth,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

/**
 * 获取推荐商品列表
 * @param {String} id 商品id（必填）
 * @param {Number} pageSize 每页条数（必填）
 * @returns {Promise} 返回推荐商品列表数据
 */
serviceApi.getRecomProductList = function(id, pageSize = 6) {
  return request({
    url: '/org-api/portal/service/getRecomProductList',
    method: 'get',
    params: {
      id: id,
      pageSize: pageSize
    },
    baseURL: baseUrl.apiBaseAuth,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

/**
 * 获取推荐服务机构列表
 * @param {String} id 机构id（必填）
 * @param {Number} pageSize 每页条数（必填）
 * @returns {Promise} 返回推荐服务机构列表数据
 */
serviceApi.getRecomServiceList = function(id, pageSize = 6) {
  return request({
    url: '/org-api/portal/service/getRecomList',
    method: 'get',
    params: {
      id: id,
      pageSize: pageSize
    },
    baseURL: baseUrl.apiBaseAuth,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export default serviceApi

